module.exports = __webpack_public_path__ + "static/media/Unitifi-Primary.5891d46e.svg";